'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Works = void 0;
const $ = require("jquery");
class Works {
    constructor() {
        const self = this;
        // 画面初期読み込み時
        this.loadChangeWorksContent();
        // 写真コンテンツを隠す
        $(".bulletPhotoContents").hide();
        // Movie / Photographの切り替え
        $('.trigWorksCategory').on('click', (e) => {
            $('.trigWorksCategory').removeClass('active');
            $(e.currentTarget).addClass('active');
            const tab = $(e.currentTarget).attr('data-tab');
            switch (tab) {
                case 'works':
                    $('.bulletWorksCategoryPhoto').hide();
                    $('.bulletWorksCategoryMovie').show();
                    break;
                case 'photo':
                    $('.bulletWorksCategoryPhoto').show();
                    $('.bulletWorksCategoryMovie').hide();
                    break;
            }
        });
        // カテゴリー切り替え
        $('.trigWorksTab').click(function () {
            const tab = $(this).data('tab');
            self.changeWorksContent(tab);
        });
    }
    // ハッシュリンクの対応
    loadChangeWorksContent() {
        const urlHash = location.hash;
        if (urlHash) {
            const tab = urlHash.replace(/#/g, "");
            this.changeWorksContent(tab);
        }
        else {
            const tab = 'company';
            this.changeWorksContent(tab);
        }
    }
    // カテゴリー切り替え
    changeWorksContent(tab) {
        $('.bulletWorksContents').removeClass('active').hide();
        $(`.bulletWorksContents[data-tab="${tab}"]`).addClass('active').show();
        // アクティブなタブの切り替え
        $('.trigWorksTab').removeClass('active');
        $(`.trigWorksTab[data-tab="${tab}"]`).addClass('active');
        // 表示するコンテンツの切り替え
        $('.bulletWorksContents').removeClass('active').hide();
        $(`.bulletWorksContents[data-tab="${tab}"]`).addClass('active').show();
    }
}
exports.Works = Works;
exports.default = Works;
